import { useEffect, useRef } from "react";
import { useTheme } from "next-themes";

const UnicornBackground = () => {
  const initialized = useRef(false);
  const { resolvedTheme } = useTheme();
  const isDark = resolvedTheme === "dark";

  useEffect(() => {
    if (!isDark) return;
    if (initialized.current) return;
    initialized.current = true;

    const load = () => {
      const existingScript = document.querySelector(
        'script[src*="unicornStudio"]'
      );
      if (existingScript) {
        if ((window as any).UnicornStudio?.init) {
          (window as any).UnicornStudio.init();
        }
        return;
      }

      (window as any).UnicornStudio = { isInitialized: false };
      const script = document.createElement("script");
      script.src =
        "https://cdn.jsdelivr.net/gh/hiunicornstudio/unicornstudio.js@v2.0.5/dist/unicornStudio.umd.js";
      script.onload = () => {
        if (document.readyState === "loading") {
          document.addEventListener("DOMContentLoaded", () => {
            (window as any).UnicornStudio.init();
          });
        } else {
          (window as any).UnicornStudio.init();
        }
      };
      (document.head || document.body).appendChild(script);
    };

    if ('requestIdleCallback' in window) {
      (window as any).requestIdleCallback(load, { timeout: 3000 });
    } else {
      setTimeout(load, 2000);
    }
  }, [isDark]);

  if (!isDark) return null;

  return (
    <div
      data-us-project="ijz2c5oTTMqf2geIMYTl"
      className="fixed inset-0 w-full h-full pointer-events-none"
      style={{ zIndex: -1 }}
    />
  );
};

export default UnicornBackground;
